import React, { FC } from 'react';
import {
  Text,
  Box,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalSize,
  ButtonAppearance,
  Button,
  ModalClose,
} from '@bechtel/gds';
import { ApolloError } from '@apollo/client';
import { t, Trans } from '@lingui/macro';
import { UpdateCommodityLocationDescriptionError } from '@bechtel/types';
import { UpdateCommodityLocationDescriptionErrorProps } from '../types';

const getErrorMessage = (error: UpdateCommodityLocationDescriptionErrorProps['error']) => {
  if (error instanceof ApolloError) {
    return <Trans>Network error has occured.Please close button and try again.</Trans>;
  }
  switch (error) {
    case UpdateCommodityLocationDescriptionError.INVALID_COMMODITY_ID:
      return <Trans>Invalid commodity id.</Trans>;
    case UpdateCommodityLocationDescriptionError.MISSING_REQUIRED_PERMISSION:
      return <Trans>Required permissions are missing.</Trans>;
    case UpdateCommodityLocationDescriptionError.UPDATE_LOCATION_DESCRIPTION_ERRORED:
      return <Trans>Error while updating location description.</Trans>;
    case UpdateCommodityLocationDescriptionError.COMMODITY_ALREADY_APPROVED:
      return <Trans>Commodity already approved.</Trans>;
    default:
      return <Trans>An error has occured. Please click close button and try again.</Trans>;
  }
};

const UpdateCommodityLocationDescError: FC<UpdateCommodityLocationDescriptionErrorProps> = ({ error, close }) => {
  return (
    <Modal visible size={ModalSize.DEFAULT} style={{ width: '552px', height: '275px' }}>
      <ModalHeader title={t`Update Commodity Location Description Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeader>
      <ModalBody>
        <Box p={{ sm: '500' }}>
          <Text size="500">{getErrorMessage(error)}</Text>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button appearance={ButtonAppearance.SECONDARY} onClick={close}>
              <Trans>Close</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
export default UpdateCommodityLocationDescError;
